import type {CoreClientDiaryEntriesListParams} from '../../../../../api/types/core/methods';
import type {CoreDiaryEntryApiModel} from '../../../../../api/types/core/models';

export abstract class ListDiaryEntriesQuery {
  abstract exec(
    props: ListDiaryEntriesQuery.Props,
  ): Promise<ListDiaryEntriesQuery.Response>;
}

export namespace ListDiaryEntriesQuery {
  export type Props = Partial<CoreClientDiaryEntriesListParams>;
  export type Response = CoreDiaryEntryApiModel[];
}
